import { baseUrl } from './util';
import { cacheOrCatch } from './cacheOrCatch';
import request from '@/utils/request';
import { setLocaleQuery, efFetch } from '@/utils';

/**
 * 创建产品注册记录 （warranty注册记录）
 * @param data 请求参数
 */
export const createOceanProLead = (
    data: {
        firstName: string;
        lastName: string;
        email: string;
        address: string;
        zip?: string;
        countryName: string;
        state?: string;
        county?: string;
        recaptchaResponse: string;
    },
    locale?: string,
) => {
    return request(`${baseUrl(locale)}/oceanPro/create`, {
        method: 'post',
        data,
    });
};
